import React from 'react';
import PropTypes from 'prop-types';
import SMReservationStatusView from './SMReservationStatusView';
import SMDashboardUserBaloonView from './SMDashboardUserBaloonView';
import SMConst from 'lib/SMConst';
import sprintf from 'sprintf';
import SMFormatHelper from 'components/helpers/SMFormatHelper';
import SMRenderHelper from 'components/helpers/SMRenderHelper';
import SMAppHelper from 'components/helpers/SMAppHelper';

class SMReservationHeaderView extends React.Component {

  renderSpaceMarket(reservation) {
    let priceArray = [];
    if (reservation.billing){
      if (this.props.isOwner == true) {
        priceArray.push(reservation.billing.price_both_text);
      } else {
        priceArray.push(sprintf(("%s(" + I18n.t("dashboard.label_000706") + ")"), reservation.billing.total_pay_amount_for_user_with_tax_text));
      }

      if (this.props.isOwner == false && reservation.billing.destination_type == SMConst.BillingDestinationType.Company) {
        priceArray.push(sprintf("支払い方法：%sに請求", reservation.billing.company.name));
      } else if (reservation.billing.payment_method_text) {
        priceArray.push(sprintf("支払い方法：%s", reservation.billing.payment_method_text));
      }
    }
    let priceText = priceArray.join(" ");
    let name;
    let members;
    let corpName;
    let image;
    let baloonType, baloonData;
    let authRows = [];
    let link = "#";
    let baloonButtonTitle = I18n.t("dashboard.label_000097");
    let baloonButtonLink = "#";
    let editButton = null;
    let isAppliedCoupon = null;
    let needPreview = null;
    let dueDateForApproval = null;
    let stateOfUnapprovedContent = null;

    if (reservation.due_date_for_approval) {
      dueDateForApproval = (
        <span className="message-important ml10"> {I18n.t('dashboard.label_000209')}：{reservation.due_date_for_approval}</span>
      );
    }

    if (reservation.unapproved_reservation || reservation.unapproved_reservation_from_user) {
      stateOfUnapprovedContent = (
        <span className="message-important ml10"> {I18n.t('dashboard.label_000210')}</span>
      );
    }

    if (this.props.isOwner) {
      baloonType = "User";
      baloonData = JSON.stringify(reservation.user);
      baloonButtonLink = Routes.owner_dashboard_message_path(reservation.owner.username, reservation.uid);
      name = reservation.user.contact_name;
      corpName = reservation.user.corp_name;
      image = reservation.user.profile_image;
      link = Routes.user_path(reservation.user.username);
      if (SMAppHelper.userIsCorp(reservation)) {
        corpName = reservation.user.corp_name;
      }

      if (reservation.user.is_verified_facebook) {
        authRows.push(SMFormatHelper.renderFacebookIcon());
      }
      if (reservation.user.is_verified_email) {
        authRows.push(SMFormatHelper.renderEmailIcon());
      }
      if (reservation.user.is_verified_tel) {
        authRows.push(SMFormatHelper.renderTelIcon());
      }
      if (reservation.user.is_certificated) {
        authRows.push(SMFormatHelper.renderPassport());
      }

      if (reservation.rent_type == SMConst.RentType.Stay) {
        members = (<p className="reserve-header__name-supplement">を含む{reservation.number_of_guests}名</p>);
      }
      if (reservation.can_be_edited) {
        editButton = (
          <p><a href={Routes.edit_owner_dashboard_reservation_path(reservation.owner.username, reservation.uid)} className="button-gray reserve-header__edit"><i className="fa fa-cog mr5"></i>予約を編集する</a></p>
        );
      }

    } else {
      if (reservation.owner){
        baloonType = "Owner";
        baloonData = JSON.stringify(reservation.owner);
        baloonButtonLink = Routes.dashboard_message_path(reservation.uid);
        name = SMFormatHelper.ownerName(reservation.owner);
        corpName = "";
        link = Routes.owner_path(reservation.owner.username);
        image = SMFormatHelper.ownerImageUrl(reservation.owner, reservation.owner.profile_image);
        needPreview = reservation.need_preview ? I18n.t("dashboard.label_000710") : null;
        isAppliedCoupon = reservation.billing && reservation.billing.is_applied_coupon ? <p className="reserve-header__coupon">{I18n.t("dashboard.label_000705")}</p> : null;

        if (reservation.owner.is_verified_email) {
          authRows.push(SMFormatHelper.renderEmailIcon());
        }
        if (reservation.owner.is_verified_tel) {
          authRows.push(SMFormatHelper.renderTelIcon());
        }
        if (reservation.can_be_edited) {
          editButton = (
            <p><a href={Routes.edit_dashboard_reservation_path(reservation.uid)} className="button-gray reserve-header__edit"><i className="fa fa-cog mr5"></i>予約を編集する</a></p>
          );
        }
      } else {
        baloonType = "";
        baloonData = "";
        baloonButtonLink = Routes.dashboard_message_path(reservation.uid);
        name = "ホスト未定";
        corpName = "";
        link = "";
        image = SMFormatHelper.defaultIcon();
        needPreview = reservation.need_preview ? I18n.t("dashboard.label_000710") : null;
        isAppliedCoupon = reservation.billing && reservation.billing.is_applied_coupon ? <p className="reserve-header__coupon">{I18n.t("dashboard.label_000705")}</p> : null;
      }
    }
    let directIcon = "";
    if (reservation.is_direct) {
      directIcon = <i className="fa fa-bolt mr5 icon-direct"></i>;
    }

    return (
      <div className="reserve-header">
        {editButton}
        <SMReservationStatusView reservation={reservation} className="reserve-header__status reserve-status-icon" />
        <p className="reserve-header__id">予約ID：{reservation.id}</p>
        <p className="reserve-header__date">{SMRenderHelper.renderReservationIcon(reservation)}{reservation.reserved_date_text}</p>
        <div className="reserve-header__affiliation">
          <SMDashboardUserBaloonView
            user={reservation.user}
            owner={reservation.owner}
            link={link}
            target='_blank'
            baloonType={baloonType}
            baloonData={baloonData}
            baloonButtonTitle={baloonButtonTitle}
            baloonButtonLink={baloonButtonLink}
            image={image}
            className="js-baloon reserve-header__img"
            name={name} />
          <p className="reserve-header__name">
            {directIcon}{ (!reservation.owner || SMAppHelper.ownerIsDeleted(reservation.owner)) ? name : <a href={link} target="_blank">{name}</a>}
          </p>
          {members}
          <p className="reserve-header__company">{corpName}</p>
          <p className="reserve-header__icon">
            {authRows}
          </p>
        </div>
        {(!reservation.owner || SMAppHelper.ownerIsDeleted(reservation.owner)) ?
          reservation.room ? <p className="reserve-header__space">{SMFormatHelper.roomName(reservation.room)}（{reservation.room.space.name}）</p> : <p className="reserve-header__space">スペース未定</p> :
          <p className="reserve-header__space"><a target="_blank" href={Routes.space_room_path(reservation.room.space.username, reservation.room.uid)}>{SMFormatHelper.roomName(reservation.room)}</a>（<a target="_blank" href={Routes.space_path(reservation.room.space.username)}>{reservation.room.space.name}</a>）</p>
        }
        <p className="reserve-header__price">{priceText}{dueDateForApproval}{stateOfUnapprovedContent}</p>
        <p className="reserve-header__preview">{needPreview}</p>
        {isAppliedCoupon}
      </div>
    );
  }

  renderOwnerDirect(reservation) {
    let priceArray = [];
    if (reservation.billing){
      priceArray.push(reservation.billing.price_both_text);
    }
    let priceText = priceArray.join(" ");
    let name = reservation.user.contact_name;
    let corpName = reservation.user.corp_name;
    let authRows = [];
    let image = reservation.user.profile_image;
    let reservedDateText = "";

    if (reservation.user.is_verified_email) {
      authRows.push(SMFormatHelper.renderEmailIcon());
    }
    if (reservation.user.is_verified_tel) {
      authRows.push(SMFormatHelper.renderTelIcon());
    }

    if (reservation.user.is_certificated) {
      authRows.push(SMFormatHelper.renderPassport());
    }

    return (
      <div className="reserve-header">
        <p><a href={Routes.edit_owner_dashboard_reservation_path(reservation.owner.username, reservation.uid)} className="button-gray reserve-header__edit"><i className="fa fa-cog mr5"></i>予約を編集する</a></p>
        <SMReservationStatusView reservation={reservation} className="reserve-header__status reserve-status-icon" />
        <p className="reserve-header__id">予約ID：{reservation.id}</p>
        <p className="reserve-header__date">{reservation.reserved_date_text}</p>
        <div className="reserve-header__affiliation">
          <img src={image} className="reserve-header__img" alt={name} />
          <p className="reserve-header__name">{name}</p>
          <p className="reserve-header__company">{corpName}</p>
          <p className="reserve-header__icon">
            {authRows}
          </p>
        </div>
        <p className="reserve-header__space"><a target="_blank" href={Routes.space_room_path(reservation.room.space.username, reservation.room.uid)}>{SMFormatHelper.roomName(reservation.room)}</a>（<a target="_blank" href={Routes.space_path(reservation.room.space.username)}>{reservation.room.space.name}）</a></p>
        <p className="reserve-header__price">{priceText}</p>
      </div>
    );
  }

  render() {
    let reservation = this.props.reservation;
    if (!reservation) return null;
    if (reservation.mediator == SMConst.ReservationMediator.SpaceMarket) {
      return this.renderSpaceMarket(reservation);
    } else {
      return this.renderOwnerDirect(reservation);
    }
  }
}
SMReservationHeaderView.propTypes = {
  isOwner: PropTypes.bool.isRequired,
  reservation: PropTypes.object.isRequired,
};
export default SMReservationHeaderView;


// WEBPACK FOOTER //
// ./app/javascript/components/dashboard/shared/SMReservationHeaderView.jsx